import { useContext } from "react";
import { TenantAppContext } from "../../contexts/TenantContext";

export const useTenantApp = () => {
    const ctx = useContext(TenantAppContext);

    if (!ctx) {
        throw new Error("useTenantApp must be used inside TenantProvider");
    }

    return ctx;
};
